import _regeneratorRuntime from "@babel/runtime-corejs2/helpers/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
/* global document: true */
/* global window: true */
/**
 * Client bootstrap.
 *
 * Import client into your app and call it with correct arguments
 * to setup your redux/react client side.
 */
import path from 'path';
import * as React from 'react';
import thunk from 'redux-thunk';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { superpathjoin } from 'superpathjoin';
import { createLogger } from 'redux-logger';
import { Router, browserHistory, match } from 'react-router';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import * as Sentry from '@sentry/react';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';
import ConfigBag from '@gandi/config-bag';
import { configReducer } from '@gandi/redux-config';
import { createAppLogger } from 'gandi.redux-logger';
import { selectCurrentId, selectPersonalId } from '@gandi/redux-sharing';
import { setConfiguration, setPrivacyMode, getPrivacyMode, connectToHistory } from '@gandi/tracking';
import { createTranslator, localeSelector, reducer as localeReducer } from '@gandi/translate';
import { selectIsAuthenticatedUser, selectAuthenticatedUserInfos } from '@gandi/authentication';
import { Layers } from '@gandi/ui';
import { sanitize } from '../utils/i18n';
import { baseNameRouter } from '../utils/routing';
import { initFetcherMiddleware, pageMetaMiddleware } from '../redux/middlewares';
import * as sentryConfig from './sentryConfig';
/**
 * Create the fetcher middleware for Redux.
 */
function createFetcherMiddleware(__, config, locale) {
  var clientUri = superpathjoin(config.get('app.endpoint'), config.get('fetcher.endpoint', '/api/v5'), true);
  return initFetcherMiddleware(console, __, 'client', clientUri, locale)({});
}
function getCookie(name) {
  var cookie = {};
  document.cookie.split(';').forEach(function (el) {
    var _el$split = el.split('='),
      _el$split2 = _slicedToArray(_el$split, 2),
      k = _el$split2[0],
      v = _el$split2[1];
    cookie[k.trim()] = decodeURIComponent(v.trim());
  });
  return cookie[name];
}
var ensureDOMReady = function ensureDOMReady() {
  return new _Promise(function (resolve) {
    if (document.readyState !== 'loading') {
      resolve();
      return;
    }
    document.addEventListener('DOMContentLoaded', resolve);
  });
};

/**
 * Default router use for the client.
 * Can be overwritten in client app entry point.
 */
var _routerConfig = baseNameRouter.client;

/**
 * Initialize the client and render components into an HTML node.
 *
 * @param  {Array|Object}   options.middlewares        Redux middlewares
 *                                                      subkeys if is an object: early, later
 * @param  {Object}         options.routes             Root Route component
 * @param  {Function}       options.reducers           Reducers (not the combined one)
 * @param  {Promise}        options.routerConfig       Must return a promise with router
 *                                                      options (like history)
 * @param  {Boolean}        options.anonymousSupport   Support for anonymous mode
 */
var client = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var routes, reducers, _ref$middlewares, middlewares, _ref$routerConfig, routerConfig, _ref$anonymousSupport, anonymousSupport, _ref$globals, globals, initialState, i18n, config, _privacyMode$val, _privacyMode$val2, privacyMode, _privacyMode$val3, locale, userInfos, currentId, personalId, username, email, node, appEndpoint, rootReducer, translator, mdlewrs, orderedMiddlewares, freezeState, sentryReduxEnhancer, composeEnhancers, store, assetPrefix, extraRouteProps, fetcherEndpoint, pivoineEndpoint;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          routes = _ref.routes, reducers = _ref.reducers, _ref$middlewares = _ref.middlewares, middlewares = _ref$middlewares === void 0 ? [] : _ref$middlewares, _ref$routerConfig = _ref.routerConfig, routerConfig = _ref$routerConfig === void 0 ? _routerConfig : _ref$routerConfig, _ref$anonymousSupport = _ref.anonymousSupport, anonymousSupport = _ref$anonymousSupport === void 0 ? false : _ref$anonymousSupport, _ref$globals = _ref.globals, globals = _ref$globals === void 0 ? {} : _ref$globals;
          _context.next = 3;
          return ensureDOMReady();
        case 3:
          initialState = window.INITIAL_STATE;
          i18n = _objectSpread(_objectSpread({}, window.I18N), {}, {
            sanitize: sanitize // redefine sanitize because it is lost with server side encoding
          });
          config = new ConfigBag();
          config.merge(initialState.config);
          if (window.navigator.doNotTrack !== '1') {
            setConfiguration({
              site: config.get('tracking.id', undefined),
              collectDomain: config.get('tracking.collectDomain', undefined),
              debug: config.get('tracking.debug', false)
            });

            /* we retrieve the value set from https://www.gandi.net/en-US/contracts/privacy-policy
             *  if the user has set a value it's either 'exempt" or "optout"
             *  if not, setConfiguration tries to retrieve the value from cookie pa_privacy
             *  if there's none, it's set to 'exempt'.
             *
             *  https://developers.atinternet-solutions.com/piano-analytics/data-collection/general/cookie-storage#legacy-cookie-management
             *  This solution is temporary; once the www CMS migrates to the new piano SDK, we can remove this code,
             *  as privacyDefaultMode will do the job in @gandi/tracking. */
            privacyMode = getCookie('atauthority');
            if (
            /**
             * privacy mode is supposed to be a string ???
             */
            // $FlowFixMe[unnecessary-optional-chain]
            // $FlowFixMe[prop-missing]
            privacyMode !== null && privacyMode !== void 0 && (_privacyMode$val = privacyMode.val) !== null && _privacyMode$val !== void 0 && _privacyMode$val.visitor_mode &&
            // $FlowFixMe[unnecessary-optional-chain]
            // $FlowFixMe[prop-missing]
            (privacyMode === null || privacyMode === void 0 ? void 0 : (_privacyMode$val2 = privacyMode.val) === null || _privacyMode$val2 === void 0 ? void 0 : _privacyMode$val2.visitor_mode) !== getPrivacyMode()) {
              // $FlowFixMe[unnecessary-optional-chain]
              // $FlowFixMe[prop-missing]
              setPrivacyMode(privacyMode === null || privacyMode === void 0 ? void 0 : (_privacyMode$val3 = privacyMode.val) === null || _privacyMode$val3 === void 0 ? void 0 : _privacyMode$val3.visitor_mode);
            }
          }

          // setup Sentry client config
          if (config.get('sentry.enabled', false)) {
            /**
             * Once Sentry is loaded:
             * [1] remove the preCatch error handler,
             * [2] init Sentry
             * [3] send any exceptions that occured during bundle load
             * [4] empty the queue
             */
            // [1]
            window.onerror = undefined;
            // [2]
            Sentry.init(_objectSpread(_objectSpread({}, sentryConfig), {}, {
              dsn: config.get('sentry.dsn'),
              environment: config.get('sentry.environment'),
              release: config.get('sentry.release'),
              initialScope: {
                tags: {
                  'app.name': config.get('sentry.tags.appName')
                }
              },
              debug: config.get('sentry.debug', false),
              // Normalize redux state depth
              normalizeDepth: config.get('sentry.normalizeDepth', 6),
              // Lower this in your app config if state payload is too big
              // Additional integrations
              integrations: [
              // Capture console outputs
              new CaptureConsoleIntegration({
                // Only capture `console.error`: replaces manual calls from gandi.redux-logger and ensure wider catch
                levels: ['error']
              })],
              // Disabled since our system doesnt support client reports
              sendClientReports: false
            }));

            // [3]
            (window._r || []).forEach(function (err) {
              Sentry.captureException(err);
            });
            // [4]
            window._r = undefined;
            locale = localeSelector(initialState);
            if (selectIsAuthenticatedUser(initialState)) {
              userInfos = selectAuthenticatedUserInfos(initialState);
              currentId = selectCurrentId(initialState);
              personalId = selectPersonalId(initialState); // $FlowIgnore[incompatible-use] Here we are authenticated.
              username = userInfos.username, email = userInfos.email;
              Sentry.setContext('user', {
                // otherwise sentry automatically creates one
                id: personalId,
                username: username,
                locale: locale,
                email: email,
                'Current Organization ID': currentId,
                'Personal Organization ID': personalId
                // For A/B testing: Add 'segment' key.
              });
            } else {
              Sentry.setContext('user', {
                username: 'anonymous',
                locale: locale
              });
            }
          }
          node = document.querySelector(config.get('appCssSelector'));
          appEndpoint = config.get('app.endpoint');
          /* eslint-disable camelcase, no-undef */
          // $FlowIgnore[cannot-resolve-name] Webpack global
          __webpack_public_path__ = superpathjoin(appEndpoint,
          // $FlowIgnore[cannot-resolve-name] Webpack global
          __webpack_public_path__, true);
          /* eslint-enable camelcase, no-undef */

          // $FlowFixMe[cannot-spread-indexer]
          rootReducer = combineReducers(_objectSpread({
            locale: localeReducer,
            config: configReducer
          }, reducers));
          translator = createTranslator(i18n);
          mdlewrs = [thunk];
          if (globals.__ENV__ === 'development') {
            mdlewrs.push(createAppLogger());
            mdlewrs.push(createLogger({
              logger: console,
              collapsed: true
            }));
          }
          orderedMiddlewares = Array.isArray(middlewares) ? {
            beforeFetcher: [],
            afterFetcher: middlewares
          } : {
            beforeFetcher: middlewares.beforeFetcher || [],
            afterFetcher: middlewares.afterFetcher || []
          };
          mdlewrs.push.apply(mdlewrs, [pageMetaMiddleware].concat(_toConsumableArray(orderedMiddlewares.beforeFetcher), [createFetcherMiddleware(translator.translate, config, i18n.locale)], _toConsumableArray(orderedMiddlewares.afterFetcher)));

          // detect state mutations in development
          if (globals.__DEV__) {
            freezeState = require('../redux/middlewares/freezeState').freezeState; // eslint-disable-line global-require
            mdlewrs.push(freezeState);
          }
          sentryReduxEnhancer = Sentry.createReduxEnhancer({
            // Optionally pass options: https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/
            actionTransformer: function actionTransformer(action) {
              var _action$meta;
              // Do not register redux-form actions about password
              if ((action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.field) === 'password') {
                return null;
              }
              return action;
            },
            stateTransformer: function stateTransformer(state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                config: '-removed-',
                gandiReduxResource: '-removed-'
              });
            }
          });
          composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
          store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware.apply(void 0, mdlewrs), sentryReduxEnhancer));
          assetPrefix = globals.__DEV__ ? 'assets' : 'dist/public';
          extraRouteProps = {
            assetEndpoint: appEndpoint,
            assetPrefix: assetPrefix,
            manifestContent: window.MANIFEST,
            translator: translator,
            store: store
          };
          fetcherEndpoint = config.get('fetcher.endpoint', '/api/v5');
          pivoineEndpoint = path.join(appEndpoint, fetcherEndpoint); // $FlowIgnore[unused-promise]
          routerConfig(appEndpoint, anonymousSupport, pivoineEndpoint)(store).then(function (routerOptions) {
            var history = routerOptions && routerOptions.history ? routerOptions.history : browserHistory;
            var finalRoutes = routes(extraRouteProps);
            connectToHistory({
              history: history,
              match: match,
              baseURL: superpathjoin(config.get('public_url'), config.get('app.endpoint')),
              routes: finalRoutes
            });
            var app = /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(Layers, null, /*#__PURE__*/React.createElement(Provider, {
              store: store
            }, /*#__PURE__*/React.createElement(Router, {
              history: history,
              routes: finalRoutes
            }))));

            // $FlowIgnore[incompatible-call]
            hydrate(app, node);
          });
          if (!globals.__DEV__) {
            try {
              // eslint-disable-next-line no-console
              console.info('ₒ  Gandi.net\n' + 'ᘜ  #no_bullshit\n\n' + "Hello developer, you're reading, we are hiring\n" + 'See https://www.welcometothejungle.co/companies/gandi ' + 'or mailto:jobs@gandi.net :)');
            } catch (err) {
              // No error handling needed here.
            }
          }
        case 28:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function client(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default client;